import { createSelector } from '@ngrx/store';
import { getDragonflyState } from '../reducers';

export const getSearchBulkState = createSelector(getDragonflyState, (state) => state.searchBulk);

export const getPanelExpansion = createSelector(
  getSearchBulkState,
  ({ panelExpanded }) => panelExpanded,
);

export const getProfileModelValues = createSelector(
  getSearchBulkState,
  ({ profileModelValues }) => profileModelValues,
);

export const getProfileModel = createSelector(
  getSearchBulkState,
  ({ profileModel }) => profileModel,
);

export const getConfigurationName = createSelector(
  getSearchBulkState,
  ({ configurationName }) => configurationName,
);

export const getIsActive = createSelector(getSearchBulkState, ({ isActive }) => isActive);
